<template>
    <div class="cell" :style="{width:config.width + 'px'}" v-if="config && config.visible"
         :class="[field, align, {clickable, padded, fill, highlight, hasSuffix, full}]">
        <div class="cell-inner">
            <div class="cell-content" v-if="hasDefault">
                <div class="top">
                    <slot></slot>
                </div>
                <div class="sub" v-show="hasSub">
                    <slot name="sub"></slot>
                </div>
            </div>
            <div class="suffix" v-if="hasSuffix">
                <slot name="suffix"></slot>
            </div>
            <div class="actions" v-if="hasActions">
                <slot name="actions"></slot>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: "sc-table-cell",
  props: {
    columns: {},
    field: {},
    clickable: {
      default: false,
    },
    highlight: {
      default: false,
    },
    padded: {
      default: true
    },
    full: {
      default: false,
    },
    table: {}
  },
  computed: {
    hasSub() {
      return !!this.$slots['sub']
    },
    hasActions() {
      return !!this.$slots['actions']
    },
    hasSuffix() {
      return !!this.$slots['suffix']
    },
    hasDefault() {
      return !!this.$slots.default
    },

    config() {
      if (this.table) {
        if (this.table.columns && this.table.columns[this.field]) {
          return this.table.columns[this.field]
        }
      } else {
        if (this.columns && this.columns[this.field]) {
          return this.columns[this.field]
        }
      }
    },

    fill() {
      return !!this.config.fill;
    },

    align() {
      if (this.config.align) {
        return 'align-' + this.config.align;
      }
    }
  }
}
</script>

<style scoped lang="scss">
.cell {
    box-sizing: border-box;
    flex-shrink: 0;
    flex-grow: 0;
}

.cell.fill {
    flex-grow: 1;
}

.cell-inner {
    display: flex;
    position: relative;
    align-items: center;
}

.cell.full .cell-inner {
    width: 100%;
}

.cell.highlight .cell-inner:after {
    content: '';
    position: absolute;
    left: 0.0em;
    right: 0.0em;
    top: 0.2em;
    bottom: 0.2em;
    border-radius: 0.2em;
    border: 1px solid #ccc;
    transition-property: box-shadow, border;
    transition-duration: 0.2s;
    transition-timing-function: ease-in-out;
    cursor: pointer;
}

.cell.highlight .cell-inner:hover:after {

}

.cell.clickable {
    cursor: pointer;
}

.cell .cell-content {
    word-wrap: break-word;
    overflow-wrap: break-word;
    hyphens: auto;
    padding: 0 16px;
    flex: 1;
    box-sizing: border-box;
}

.cell.align-right {
    justify-content: flex-end;
}

.cell.align-right .cell-content {
    text-align: right;
}

.cell.padded .cell-content {
    padding: 14px 16px;
}

.cell.hasSuffix .cell-content {
    flex: initial;
    padding-right: 10px;
}

.top {
    font-weight: 500;
    font-size: 0.9em;
}

.sub {
    font-weight: 700;
    font-size: 0.7em;
    margin-top: 0.3em;
    line-height: 1.4em;
}

.actions {
    display: flex;
    /*margin-left: 8px;*/
    padding: 2px 0;
    padding-left: 8px;
}

.align-right.actions {
    justify-content: flex-end;
    margin-left: 0;
    padding-right: 16px;
}

.open-in-teamviewer i {
    margin-top: 1px;
}

.suffix {
    display: flex;
    align-items: center;
    height: 100%;
}
</style>